import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import {
  LightMode,
  DarkMode,
  SettingsBrightness,
} from '@mui/icons-material';
import { useDarkMode } from 'lib/hooks/useDarkMode';

export const DarkModeToggle = () => {
  const { mode, setMode } = useDarkMode();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleModeSelect = (newMode: 'light' | 'dark' | 'system') => {
    setMode(newMode);
    handleClose();

    // Force immediate page refresh to ensure theme changes apply
    // This is a temporary solution to ensure the theme updates properly
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        window.location.reload();
      }
    }, 100);
  };

  const getIcon = () => {
    switch (mode) {
    case 'light':
      return <LightMode />;
    case 'dark':
      return <DarkMode />;
    case 'system':
      return <SettingsBrightness />;
    default:
      return <SettingsBrightness />;
    }
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        aria-label="Toggle theme mode"
        aria-controls={open ? 'theme-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        className="text-white hover:text-teal"
      >
        {getIcon()}
      </IconButton>
      <Menu
        id="theme-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <MenuItem
          onClick={() => handleModeSelect('light')}
          selected={mode === 'light'}
        >
          <LightMode className="mr-2" />
          Light
        </MenuItem>
        <MenuItem
          onClick={() => handleModeSelect('dark')}
          selected={mode === 'dark'}
        >
          <DarkMode className="mr-2" />
          Dark
        </MenuItem>
        <MenuItem
          onClick={() => handleModeSelect('system')}
          selected={mode === 'system'}
        >
          <SettingsBrightness className="mr-2" />
          System
        </MenuItem>
      </Menu>
    </>
  );
};
